import * as types from './types';

export const accountMutations = {
  [types.SET_ACCOUNT_INFO](state, payload) {
    state.account = payload;
    console.log({'mutations.js:6 state.account' : state.account});
  },
  [types.UPDATE_ACCOUNT_INFO](state, payload) {
    const { name, value } = payload;
    state.account.user[name] = value;
  },
  [types.UPDATE_INAPPNOTICE](state, payload) {
    state.account.inapp_notices = payload;
  },
  [types.SET_ROUTE_BEFORE_BLOCK](state, payload) {
    state.routeBeforeBlock = payload;
  }
}